import { useState, useEffect, useCallback, useMemo } from 'react';
import { Annotation } from "./Annotation";
import { conditionMapping } from "../interface";

import { useTranslation } from "react-i18next";

const DirectionSelector = ({ imagedoms, images, directions, setDraggingGlobal, setWeightsTipInit, imageIndex, setSelection, textColor, direction }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [startX, setStartX] = useState(0);
    const [dragging, setDragging] = useState(false);
    const { t } = useTranslation();
    const MAX_STEPS = 1;

    useEffect(() => {
        if (direction && imageIndex >= 0 && imageIndex < direction.length) {
            const currentDirection = direction[imageIndex];
            const index = conditionMapping.indexOf(currentDirection);
            setSelectedImageIndex(index);
        }
    }, [direction, imageIndex]);

    const updateImageIndex = useCallback((currentX) => {
        const deltaX = currentX - startX;
        if (Math.abs(deltaX) >= 10 ) {
            let steps = Math.floor(deltaX / 10);
            steps = Math.max(-MAX_STEPS, Math.min(steps, MAX_STEPS));
            let newIndex = selectedImageIndex + steps;
            if (newIndex >= images.length) {
                newIndex = 0;
            } else if (newIndex < 0) {
                newIndex = images.length - 1;
            }
            setSelectedImageIndex(newIndex);
            setSelection(imageIndex, newIndex);
            setStartX(currentX);
        }
    }, [startX, selectedImageIndex, images.length, setSelection, imageIndex]);

    const handleMouseMove = useCallback((event) => {
        if (dragging) {
            requestAnimationFrame(() => updateImageIndex(event.clientX));
        }
    }, [dragging, updateImageIndex]);

    const handleMouseUp = useCallback(() => {
        setDragging(false);
        setDraggingGlobal(false);
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    }, [setDraggingGlobal, handleMouseMove]);

    useEffect(() => {
        if (dragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [dragging, handleMouseMove, handleMouseUp]);

    const handleMouseDown = useCallback((event) => {
        setWeightsTipInit(true)
        setStartX(event.clientX);
        setDragging(true);
        setDraggingGlobal(imageIndex);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }, [imageIndex, setDraggingGlobal, handleMouseMove, handleMouseUp]);

    const currentDirection = useMemo(() => directions[selectedImageIndex % directions.length], [selectedImageIndex, directions]);
    const sliderPosition = useMemo(() => (selectedImageIndex / (images.length - 1)) * 100, [selectedImageIndex, images.length]);

    // const imagedoms = useMemo(() =>
    //     <img
    //     src={shipPng}
    //     width="100%"
    //     height="100%"
    //     alt="Selectable angle"
    //     className="w-full h-full"
    //     draggable="false"
    // />
    // , [shipPng]);
    return (
        <>
            <div className="relative w-20 h-20 p-2 mt-1.5 bg-white rounded-lg z-30"
                 onMouseDown={handleMouseDown}>
                <div className="absolute top-[-1px] left-0 text-sm z-50">
                    <Annotation left={'-1rem'} text={t('RODIN_WEIGHT_DIRECT_DESC')}/>
                </div>
                {images[selectedImageIndex] ? (
                    <>
                        {/* {imagedoms[selectedImageIndex]} */}
                        <div className='absolute w-full h-full left-0 top-0 z-[-1] overflow-x-hidden'>
                            <div style={{left:`-${(selectedImageIndex-1)*80}px`}} className='absolute h-full w-[1000%]'>
                                {imagedoms}
                            </div>
                        </div>
                        
                        
                        <div
                            className="absolute z-[2] top-0 left-9 w-[10px] h-1/3 flex text-sm whitespace-nowrap items-center justify-center"
                            style={{lineHeight: 0.9, fontWeight: 1000, color: textColor, zIndex: -1}}>
                            {currentDirection}
                        </div>
                    </>
                ) : (
                    <div className="w-full h-full flex flex-col items-center text-sm justify-center text-gray-500">
                        <div style={{fontWeight: 1000, color: textColor}}>{t('RODIN_WEIGHT_UNKNOWN')}</div>
                    </div>
                )}
            </div>
            <div className="w-[72px] bottom-[1px] h-[3px] left-1 bg-gray-200 mt-2 absolute z-50 rounded overflow-hidden">
                <div className="bg-gray-500 h-[2px] w-2.5 rounded-full"
                     style={{marginLeft: `${sliderPosition / 1.6 - 1.8}px`}}></div>
            </div>
        </>
    );
};

export default DirectionSelector;
